import {
  ANALYTICS_IDENTITY,
  CHATWOOT_RESET,
  CHATWOOT_SET_USER,
} from '../constants/appEvents';
import AnalyticsHelper from './AnalyticsHelper';
import DashboardAudioNotificationHelper from './AudioAlerts/DashboardAudioNotificationHelper';
import { emitter } from 'shared/helpers/mitt';

export const initializeAnalyticsEvents = () => {
  AnalyticsHelper.init();
  emitter.on(ANALYTICS_IDENTITY, ({ user }) => {
    AnalyticsHelper.identify(user);
  });
};

export const initializeAudioAlerts = user => {
  const { ui_settings: uiSettings } = user || {};
  const {
    always_play_audio_alert: alwaysPlayAudioAlert,
    enable_audio_alerts: audioAlertType,
    alert_if_unread_assigned_conversation_exist: alertIfUnreadConversationExist,
    notification_tone: audioAlertTone,
    sz_permissions_onboarded_at: szPermissionsOnboardedAt,
    // UI Settings can be undefined initially as we don't send the
    // entire payload for the user during the signup process.
  } = uiSettings || {};

  // SZ_PERMISSIONS_GATE_v1_20260519: após o usuário completar o onboarding
  // de permissões, defaults sobem para "tocar para conversas atribuídas a mim,
  // sempre". Usuário pode customizar via Settings > Notifications.
  const hasOnboarded = !!szPermissionsOnboardedAt;
  const defaultAudioType = hasOnboarded ? 'assigned' : 'none';
  const defaultAlwaysPlay = hasOnboarded;

  DashboardAudioNotificationHelper.set({
    currentUser: user,
    audioAlertType: audioAlertType || defaultAudioType,
    audioAlertTone: audioAlertTone || 'ding',
    alwaysPlayAudioAlert:
      alwaysPlayAudioAlert === undefined
        ? defaultAlwaysPlay
        : alwaysPlayAudioAlert,
    alertIfUnreadConversationExist: alertIfUnreadConversationExist || false,
  });
};

export const initializeChatwootEvents = () => {
  emitter.on(CHATWOOT_RESET, () => {
    if (window.$chatwoot) {
      window.$chatwoot.reset();
    }
  });
  emitter.on(CHATWOOT_SET_USER, ({ user }) => {
    if (window.$chatwoot) {
      window.$chatwoot.setUser(user.email, {
        avatar_url: user.avatar_url,
        email: user.email,
        identifier_hash: user.hmac_identifier,
        name: user.name,
      });
      window.$chatwoot.setCustomAttributes({
        signedUpAt: user.created_at,
        cloudCustomer: 'true',
        account_id: user.account_id,
      });
    }

    initializeAudioAlerts(user);
  });
};
